import React from 'react';
import { DEFAULT_IMG_URL } from '../../lib/constants';

interface Props {
  uploadDate: string;
  name?: string;
  description?: string;
  posterUrl?: string;
  id?: string;
  contentUrl?: string | null;
  duration?: string;
}

const SchemaVideo = ({
  id = '',
  uploadDate,
  name = 'NAF - Norges Automobil-Forbund | NAF',
  description = '',
  posterUrl = DEFAULT_IMG_URL,
  contentUrl = '',
  duration = '',
}: Props) => {
  const structuredData = `{
        "@context": "http://schema.org",
		    "@type": "VideoObject",
        "uploadDate": "${uploadDate}",
        "name": "${name}",
        "thumbnail": "${posterUrl}",
        "thumbnailUrl": "${posterUrl}",
        ${description ? `"description": "${description?.replace(/"/g, '')}",` : ''}
        ${contentUrl ? `"contentUrl": "${contentUrl}",` : ''}
        ${duration ? `"duration": "${duration}"` : ''}
    }`;

  return (
    // eslint-disable-next-line react/no-danger
    <script type="application/ld+json" key={`carJSON-${id}`} dangerouslySetInnerHTML={{ __html: structuredData }} />
  );
};

export default SchemaVideo;
